import { ProdStackManagerData } from 'types/prodStakManagerTypes';
import { GetProdStackManagerDataService } from 'types/services';
import { m8API } from '../m8';
import { normalizeM8ProdStackDTO } from '../utils/normalizeM8ProdStackDTO';

export const getProdStackManagerData: GetProdStackManagerDataService = async () => {
  const prodStackManagerData: ProdStackManagerData = {};

  const m8ProdStackDTO = await m8API.user.getProdStackInfo();

  if (m8ProdStackDTO) {
    prodStackManagerData.prodStackInfo = normalizeM8ProdStackDTO(
      m8ProdStackDTO
    ).toProdStackInfo();
  }

  return prodStackManagerData;
};
